import { colorConstants } from 'config/colorConstants';
import dayjs from 'dayjs';
import _ from 'lodash';
import { monthData } from 'utils/Calender';
import { formatNumWithKMBAlt } from 'utils/helperMethods';

export const eventsListDataParser = (data: any[]) => {
    try {
        const result = data.map((event: any) => {
            const { visibleEventData, eventDetailsData } = event;

            return {
                Account: visibleEventData?.eventBasicFields?.dim2AttributeNames || [],
                'All Event': visibleEventData?.eventBasicFields?.eventName,
                Products: visibleEventData?.eventBasicFields?.dim1AttributeNames || [],
                edit: eventDetailsData,
                key: visibleEventData?.eventBasicFields?.eventId,
                isActive: visibleEventData?.eventBasicFields?.activeStatus,
            };
        });
        return result;
    } catch (error) {
        throw error;
    }
};

//calender parser
export const recommendationCalenderTableParser = (payload: any = {}, config: any) => {
    const { promoRecommendation, commonConfig } = config;
    const promoTypeColorMapping: any = promoRecommendation.promoTypeColorMapping;
    const { data, startWeek = [], endWeek = [] } = payload;
    const result: any = [];
    //console.log(startWeek, endWeek, data, 'logging g');
    const weekPercentage = 25;
    const marginBlock = 10;
    const barHeight = 8;
    const weekDivision = 4;
    try {
        data.forEach((event: any, index: number) => {
            const { visibleEventData } = event;

            const tempObj: any = {
                event: visibleEventData?.eventBasicFields?.eventName,
                // event: `${event.dim1}`,
                key: visibleEventData?.eventBasicFields?.eventId,
                isActive: visibleEventData?.eventBasicFields?.activeStatus,
            };
            for (let i = 0; i < endWeek.length; i += weekDivision) {
                tempObj[dayjs(endWeek[i]).format('MM/DD/YY')] = [];
            }
            // sorting trends in ascending order of startdate
            // const sortedArray = event.activeTrends.slice().sort(function (a: any, b: any) {
            //     return new Date(a.startTimestamp).getTime() - new Date(b.startTimestamp).getTime();
            // });
            let previousEndIndex = 0;
            let startMonthIndexMapping = 0;
            let updatedMarginTop = 0;
            let updatedMarginPrev = 0;
            const sortedArray = [visibleEventData];
            sortedArray.forEach((visibleEventData: any, trendIndex: number) => {
                const { eventBasicFields, eventHoverData } = visibleEventData;
                const starttimestampIndex = Math.max(
                    startWeek.findIndex((date: any) => date === eventBasicFields?.startDate),
                    0,
                );
                const endtimestampIndex = Math.max(
                    endWeek.findIndex((date: any) => date === eventBasicFields?.endDate),
                    0,
                );
                const startMonthIndex = Math.floor(starttimestampIndex / weekDivision) * weekDivision;
                const promoType = String(eventHoverData?.tacticDescription).toLowerCase();
                const weekDifference = calculateWeeksDifference(starttimestampIndex, endtimestampIndex);
                const marginLeft = calculateWeeksDifference(startMonthIndex, starttimestampIndex) * weekPercentage;
                const width = `calc(${weekDifference * weekPercentage + weekPercentage}% + ${
                    weekDifference / weekDivision
                }px)`;

                //for index ===0 or if(startmonth index of previous itemis equal to start month index of current item)
                if (trendIndex === 0 || startMonthIndexMapping === startMonthIndex) {
                    updatedMarginTop = marginBlock;
                    updatedMarginPrev += 18; //(padding 10 + height of bar 8)
                    //if starttimestampindex of current item is greater than endtimestamp index of prev item , dont change margin top
                } else if (starttimestampIndex > previousEndIndex) {
                    updatedMarginTop = updatedMarginPrev;
                    //if starttimestampindex of current item is less or equal to endtimestamp index of prev item , change margin top
                } else if (starttimestampIndex <= previousEndIndex) {
                    updatedMarginPrev += 18;
                    updatedMarginTop = updatedMarginPrev;
                }
                previousEndIndex = endtimestampIndex;
                startMonthIndexMapping = startMonthIndex;

                const trendObj = {
                    style: {
                        // marginTop: (trendIndex + 1) * marginBlock + (trendIndex + 1) * barHeight,
                        marginTop: trendIndex === 0 ? marginBlock : updatedMarginTop,
                        background:
                            promoType in promoTypeColorMapping
                                ? promoTypeColorMapping[promoType].color
                                : colorConstants.brown,
                        marginLeft: `${marginLeft}%`,
                        width: width,
                    },
                    infoData: {
                        promoMech: eventBasicFields?.eventName,
                        duration: eventHoverData?.duration + (eventHoverData?.duration === 1 ? ' Week' : ' Weeks'),
                        tacticDescription:
                            promoType in promoTypeColorMapping
                                ? promoTypeColorMapping[promoType].label
                                : _.startCase(promoType),
                        dim1AttributeNames: eventHoverData?.dim1AttributeNames?.join(', '),
                        startDate: dayjs(eventBasicFields?.startDate).format(commonConfig?.dateFormatAlt),
                        endTimestamp: dayjs(eventBasicFields?.endDate).format(commonConfig?.dateFormatAlt),
                        totalVolume: _.isNull(eventHoverData?.totalVolume)
                            ? ''
                            : `${formatNumWithKMBAlt(eventHoverData?.totalVolume, 2, 2)}`,
                        totalGsv: _.isNull(eventHoverData?.totalGsv)
                            ? ''
                            : `${commonConfig.units.currency}${formatNumWithKMBAlt(eventHoverData?.totalGsv, 2, 2)}`,
                        totalNsv: _.isNull(eventHoverData?.totalNsv)
                            ? ''
                            : `${commonConfig.units.currency}${formatNumWithKMBAlt(eventHoverData?.totalNsv, 2, 2)}`,
                        totalKindProfit: _.isNull(eventHoverData?.totalKindProfit)
                            ? ''
                            : `${commonConfig.units.currency}${formatNumWithKMBAlt(
                                  eventHoverData?.totalKindProfit,
                                  2,
                                  2,
                              )}`,
                        totalRetailerProfit: _.isNull(eventHoverData?.totalRetailerProfit)
                            ? ''
                            : `${commonConfig.units.currency}${formatNumWithKMBAlt(
                                  eventHoverData?.totalRetailerProfit,
                                  2,
                                  2,
                              )}`,
                        promoSpends: _.isNull(eventHoverData?.promoSpends)
                            ? ''
                            : `${commonConfig.units.currency}${formatNumWithKMBAlt(eventHoverData?.promoSpends, 2, 2)}`,
                        percentageTradeSpendsGsv: _.isNull(eventHoverData?.percentageTradeSpendsGsv)
                            ? ''
                            : formatNumWithKMBAlt(eventHoverData?.percentageTradeSpendsGsv, 2, 2) + '%',
                        percentageTradeSpendsNsv: _.isNull(eventHoverData?.percentageTradeSpendsNsv)
                            ? ''
                            : formatNumWithKMBAlt(eventHoverData?.percentageTradeSpendsNsv, 2, 2) + '%',
                        totalProfitPercentage: _.isNull(eventHoverData?.totalProfitPercentage)
                            ? ''
                            : formatNumWithKMBAlt(eventHoverData?.totalProfitPercentage, 2, 2) + '%',
                        incrementalVolume: _.isNull(eventHoverData?.incrementalVolume)
                            ? ''
                            : `${formatNumWithKMBAlt(eventHoverData?.incrementalVolume, 2, 2)}`,
                        incrementalGsv: _.isNull(eventHoverData?.incrementalGsv)
                            ? ''
                            : `${commonConfig.units.currency}${formatNumWithKMBAlt(
                                  eventHoverData?.incrementalGsv,
                                  2,
                                  2,
                              )}`,
                        incrementalNsv: _.isNull(eventHoverData?.incrementalNsv)
                            ? ''
                            : `${commonConfig.units.currency}${formatNumWithKMBAlt(
                                  eventHoverData?.incrementalNsv,
                                  2,
                                  2,
                              )}`,
                        incrementalProfit: _.isNull(eventHoverData?.incrementalProfit)
                            ? ''
                            : `${commonConfig.units.currency}${formatNumWithKMBAlt(
                                  eventHoverData?.incrementalProfit,
                                  2,
                                  2,
                              )}`,
                        roi: _.isNull(eventHoverData?.roi) ? '' : `${formatNumWithKMBAlt(eventHoverData?.roi, 2, 2)}`,
                        retailerIncrementalProfit: _.isNull(eventHoverData?.retailerIncrementalProfit)
                            ? ''
                            : `${commonConfig.units.currency}${formatNumWithKMBAlt(
                                  eventHoverData?.retailerIncrementalProfit,
                                  2,
                                  2,
                              )}`,
                    },
                    shared: false,
                };
                tempObj[dayjs(endWeek[startMonthIndex]).format('MM/DD/YY')].push(trendObj);
            });

            result.push(tempObj);
        });
        //tooltip item as last item
        result.push({
            event: 'tooltip-calender',
            key: 'tooltip',
        });
        return result;
    } catch (error) {
        console.log(error, 'logging er');
        throw error;
    }
};

function calculateWeeksDifference(startDateIndex: any, endDateIndex: any) {
    return endDateIndex - startDateIndex || 0;
}

//kpi table parse
export const recommendationKpiTableDataParser = (data: any[], config: any) => {
    const { promoRecommendation, commonConfig } = config;
    const kpiDataKeyMapping: any = promoRecommendation?.overlayKeys;
    const promoTypeColorMapping: any = promoRecommendation?.promoTypeColorMapping;
    try {
        const result = data.map((event: any, idx: number) => {
            const { visibleEventData } = event;
            const nestedResult: any = {};
            const isParentIdPresent = _.isFinite(visibleEventData?.eventBasicFields?.parentId);
            let arrowDetails: any = {};
            let previousItem: any = null;
            if (isParentIdPresent) {
                previousItem = data[idx - 1];
            }
            kpiDataKeyMapping?.map((item: any) => {
                if (isParentIdPresent) {
                    const { visibleEventData: previousNestedData } = previousItem;
                    arrowDetails[item?.label] =
                        visibleEventData?.eventHoverData?.[item?.dataKey] >=
                        previousNestedData?.eventHoverData?.[item?.dataKey]
                            ? 'greater'
                            : 'lesser';
                }
                if (item?.dataKey === 'tacticDescription' && visibleEventData?.eventHoverData?.[item?.dataKey]) {
                    const promoType = visibleEventData?.eventHoverData?.[item?.dataKey];
                    nestedResult[item?.label] =
                        promoType in promoTypeColorMapping
                            ? promoTypeColorMapping[promoType].label
                            : _.startCase(promoType);
                } else if (item?.dataKey === 'startDate' && visibleEventData?.eventHoverData?.[item?.dataKey]) {
                    nestedResult[item?.label] = dayjs(visibleEventData?.eventHoverData?.[item?.dataKey]).format(
                        commonConfig?.dateFormatAlt,
                    );
                } else
                    nestedResult[item?.label] = Array.isArray(visibleEventData?.eventHoverData?.[item?.dataKey])
                        ? visibleEventData?.eventHoverData?.[item?.dataKey]?.join(', ')
                        : visibleEventData?.eventHoverData?.[item?.dataKey];
            });

            nestedResult['key'] = visibleEventData?.eventBasicFields?.eventId;
            nestedResult['isActive'] = visibleEventData?.eventBasicFields?.activeStatus;
            nestedResult['arrowDetails'] = arrowDetails;

            return nestedResult;
        });
        return result;
    } catch (error) {
        throw error;
    }
};

//summary table data parser
export const summaryDataParser = (data: any[], config: any) => {
    const { promoRecommendation } = config;
    try {
        const result: any[] = [];
        if (data?.length > 0) {
            promoRecommendation.overlayKeys.forEach((item: any) => {
                const tempData: any = {};
                const dataKey = item.dataKey in data?.[0];
                if (dataKey) {
                    tempData.KPI = item.label;
                    data.forEach((dataItem: any) => {
                        const obj = {
                            pre: item.pre,
                            post: item.post,
                            val: dataItem[item.dataKey],
                        };
                        tempData[dataItem['planName']] = obj;
                    });
                    tempData['formatting'] = { pre: item.pre, post: item.post };
                    tempData.dataKey = item.dataKey;
                    result.push(tempData);
                }
            });
        }

        return result;
    } catch (error) {
        throw error;
    }
};

export const playbookDataParser = (data: any, config: any) => {
    const { promoRecommendation } = config;
    const playbookKeyMapping: any = promoRecommendation.playbookKeyMapping;
    try {
        const result: any[] = [];
        let temp: any = {};

        //for total
        Object.keys(playbookKeyMapping).map((item) => {
            temp[item] =
                playbookKeyMapping[item]?.length > 1
                    ? {
                          firstValue: Array.isArray(data?.totalData[playbookKeyMapping[item][0]])
                              ? data?.totalData[playbookKeyMapping[item][0]]
                              : data?.totalData[playbookKeyMapping[item][0]],
                          secondValue: data?.totalData[playbookKeyMapping[item][1]],
                          operator: playbookKeyMapping[item][2],
                          pre: playbookKeyMapping[item][3],
                          post: playbookKeyMapping[item][4],
                      }
                    : data?.totalData[playbookKeyMapping[item][0]];
        });
        result.push(temp);

        data?.playbookData?.map((data: any, idx: number) => {
            temp = {};
            Object.keys(playbookKeyMapping).map((item) => {
                temp[item] =
                    playbookKeyMapping[item]?.length > 1
                        ? {
                              firstValue: Array.isArray(data[playbookKeyMapping[item][0]])
                                  ? data[playbookKeyMapping[item][0]]
                                  : data[playbookKeyMapping[item][0]],
                              secondValue: data[playbookKeyMapping[item][1]],
                              operator: playbookKeyMapping[item][2],
                              pre: playbookKeyMapping[item][3],
                              post: playbookKeyMapping[item][4],
                          }
                        : data[playbookKeyMapping[item][0]];
            });
            result.push(temp);
        });
        return result;
    } catch (error) {
        throw error;
    }
};

export function bestWeeksDataParser(responseData: any) {
    // parsing best week
    const weeksPeriodsMappingData: any = [{}];
    if (responseData?.weeksEventsMapping) {
        const weeksMapResponse = JSON.parse(responseData?.weeksEventsMapping);

        monthData.forEach((item: any) => {
            const periods = Object.keys(weeksMapResponse[item.key].periods);
            const newData: any = {
                month: item.label,
                periods: periods,
                events: {},
            };
            periods.forEach((periodNumber: any) => {
                newData.events[periodNumber] = weeksMapResponse[item.key].periods[periodNumber].map((event: any) => {
                    return {
                        eventName: event,
                    };
                });
            });
            weeksPeriodsMappingData.push(newData);
        });
    }

    const bestWeeksData: any = [];
    if (responseData?.weeksData) {
        //  Border logic also should be added
        responseData.weeksData.forEach((item: any) => {
            const newValues: any = {};
            const newData = { attributeName: item.attributeName, values: newValues };
            const parsedValues = JSON.parse(item.values);
            Object.keys(parsedValues).forEach((key: any, index) => {
                newValues[key] = {
                    val: parsedValues[key],
                    color: getBestWeeksColor(parsedValues[key]),
                    isBordered: false, // add some logic
                };
            });
            bestWeeksData.push(newData);
        });
    }

    return { weeksPeriodsMappingData, bestWeeksData: bestWeeksData };
}

const getBestWeeksColor = (value: number) => {
    // for null values return white
    if (!value) return colorConstants.white;

    if (value <= 7) return colorConstants.bestWeeksDarkGreen1;
    if (value <= 14) return colorConstants.bestWeeksDarkGreen2;
    if (value <= 21) return colorConstants.bestWeeksDarkGreen3;
    if (value <= 28) return colorConstants.greyAlt1;
    if (value <= 26) return colorConstants.bestWeeksDarkRed3;
    if (value <= 44) return colorConstants.bestWeeksDarkRed2;
    return colorConstants.bestWeeksDarkRed1;
};

export const recommendationExportParser = (kpiData: any[], eventsListData: any[]) => {
    try {
        const kpiColumnsHeader =
            Array.isArray(kpiData) && kpiData.length > 0 ? Object.keys(kpiData[0]).slice(0, -3) : [];
        const eventsListColumnsHeader =
            Array.isArray(eventsListData) && eventsListData.length > 0
                ? Object.keys(eventsListData[0]).slice(0, -3)
                : [];

        const kpiDataToExport: any[] = [];
        const eventsListDataToExport: any[] = [];

        kpiData?.forEach((item: any) => {
            const tempKpiData: any[] = [];
            kpiColumnsHeader?.forEach((kpi: string) => {
                tempKpiData?.push(item?.[kpi]);
            });
            kpiDataToExport.push(tempKpiData);
        });

        eventsListData?.forEach((item) => {
            const tempEventsListData: any[] = [];
            eventsListColumnsHeader?.forEach((kpi: string) => {
                tempEventsListData?.push(Array.isArray(item?.[kpi]) ? item?.[kpi]?.join(', ') : item?.[kpi]);
            });
            eventsListDataToExport.push(tempEventsListData);
        });
        //merge export data - first events data, then kpi data
        const mergedExportHeader = [...eventsListColumnsHeader, ...kpiColumnsHeader];
        const mergedExportData = eventsListDataToExport?.map((row, i) => [...row, ...kpiDataToExport?.[i]]);
        return { header: mergedExportHeader, data: mergedExportData };
    } catch (error) {
        throw error;
    }
};
